import { render, staticRenderFns } from "./ShopSlider.vue?vue&type=template&id=349ce7d6&scoped=true"
import script from "./ShopSlider.vue?vue&type=script&lang=ts"
export * from "./ShopSlider.vue?vue&type=script&lang=ts"
import style0 from "./ShopSlider.vue?vue&type=style&index=0&id=349ce7d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349ce7d6",
  null
  
)

export default component.exports